export const ACTIVITY_PROGRAM = "program";
export const ACTIVITY_CHECKLIST = "checklist";
export const ACTIVITY_ACTION = "action";
